import { DOMElementEvent } from '../dom/DOMElementEvent.enum';
import { NotificationPriority } from './NotificationPriority.enum';

/**
 * webshopNotification class
 */
export class WebshopNotification {

    public static readonly priorityHighId: string = 'Notification-Priority-High';

    private static readonly actionId: string = 'Notification-Action';

    public readonly notificationId: string;

    public readonly ttl: number | null;

    private readonly notificationElement: Element;

    private readonly priority: NotificationPriority;

    private readonly isPersistent: boolean;

    /**
     * Ctor
     * @param notificationElement
     * @param notificationId
     * @param isPersistent false (default)
     * @param ttl null (default) in milliseconds
     */
    constructor(notificationElement: Element,
                notificationId: string,
                isPersistent: boolean = false,
                ttl: number | null = null)
    {

        this.notificationId = notificationId;
        this.notificationElement = notificationElement;
        this.notificationElement = this.decorateActions(this.notificationElement);
        this.notificationElement = this.decorateId(this.notificationElement);
        this.priority = this.hasHighPriority(notificationElement)
            ? NotificationPriority.High
            : NotificationPriority.Normal;
        this.isPersistent = isPersistent;
        this.ttl = ttl;
    }

    /**
     * Html element getter
     */
    public getNotificationElement(): Element {
        return this.notificationElement;
    }

    /**
     * Priority value getter
     */
    public getPriority(): NotificationPriority {
        return this.priority;
    }

    /**
     * Persistance value getter
     */
    public getPersistence(): Boolean {
        return this.isPersistent;
    }

    /**
     * Attaches resolve notification handlers to defined actions
     * @param notificationElement
     */
    private decorateActions(notificationElement: Element): Element {
        const content = notificationElement;

        content.querySelectorAll(`[data-js=${WebshopNotification.actionId}]`).forEach((element: Element) => {
            element.addEventListener(DOMElementEvent.Click, () => {
                window.NotificationManager.resolve(this);
            });
        });

        return content;
    }

    /**
     * Decorates notification element with provided notification id
     * @param notificationElement
     */
    private decorateId(notificationElement: Element): Element {
        const content = notificationElement;

        content.setAttribute('data-js-id', this.notificationId);

        return content;
    }

    /**
     * Checks if notification has high priority
     * @param notificationElement
     */
    private hasHighPriority(notificationElement: Element): boolean {
        const query = notificationElement.getAttribute(`data-js-priority`);

        return query !== null
            && query === WebshopNotification.priorityHighId;
    }

}
